export default __webpack_public_path__ + "static/media/email.icon.b2549a08.svg";